import http from '../../config/axios';

export const getFileLiquidation = async(nameFile) => {
    try{
        const res = await http.get(`/salary/settlement/liquidation/file/${nameFile}`)
        return res.data;
    } catch(err) {
        return err;
    }    
}

export const saveLiquidation = async(data) => {
    const res = await http.post(`/admin/salary/settlement/liquidation`, data)
    return res;    
}

export const dropLiquidation = async(uuid) => { 
    const res = await http.delete(`/admin/salary/settlement/liquidation/${uuid}`)
    return res;    
}

